import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { Button } from '@repo/ui';
import { type ReactNode } from 'react';

import PageFrame from '@shared/components/page/PageFrame';

interface Props {
  testId: TestId;
  loginButtonLabel: string;
  /** The login, shown over the page while it is asked for. */
  drawer: ReactNode;
  onLogin: () => void;
}

/** One message for every link that cannot be used — nothing tells the reasons apart. */
export default function SpanPaymentLinkInvalidContents({ testId, loginButtonLabel, drawer, onLogin }: Props) {
  const handleLogin = () => {
    onLogin();
  };

  return (
    <PageFrame testId={testId} drawer={drawer}>
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-4 text-center">
        <p className="text-body max-w-md text-base" data-testid={testId.append('message')}>
          {tr('reservations:span_payment_link.invalid')}
        </p>
        <Button
          color="brand"
          size="lg"
          className="w-full"
          label={loginButtonLabel}
          testId={testId.append('loginButton')}
          onClick={handleLogin}
        />
      </div>
    </PageFrame>
  );
}
